export const NOVABOX = 'NOVABOX';
export const SNACKBAR = 'SNACKBAR';
export const CONTEXTO = 'CONTEXTO';
export const CLEAR_STATE = 'CLEAR_STATE';
export const SET_VISAO_COLABORADOR = 'SET_VISAO_COLABORADOR';
export const MSG_TOAST = 'MSG_TOAST';
export const SET_BOX_ID = 'SET_BOX_ID';
